import { render, staticRenderFns } from "./AddApi2Role.vue?vue&type=template&id=23af4c2a"
import script from "./AddApi2Role.vue?vue&type=script&lang=js"
export * from "./AddApi2Role.vue?vue&type=script&lang=js"
import style0 from "./AddApi2Role.vue?vue&type=style&index=0&id=23af4c2a&prod&media=screen&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports